<template>
  <div>
    <v-row>
      <v-col class="pr-sm-2">
        <BaseFormSelect
          id-element="insuranceCompanyQuotation"
          placeholder="Escolher"
          label-text="Seguradora"
          v-model="editForm.seguradora"
          :items="insuranceCompanyOptions"
          item-text="nome"
          item-value="codigo"
          required
          :rules="[requiredInput]"
          :return-object="true"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="insuredAreaQuotation"
          placeholder="0,00"
          label-text="Área Segurada (ha)"
          v-model="editForm.area_segurada"
          required
          :rules="[requiredInput, aboveZero]"
          :money="typeDecimal"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="plantValueQuotation"
          placeholder="0,00"
          label-text="Valor da Planta"
          v-model="editForm.valor_planta"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row class="mb-8">
      <v-col cols="12">
        <p class="primary--text form__title">
          Coberturas
        </p>
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseFormSelect
          ref="coverageInput"
          v-model="selectedCoverage"
          :items="coverageOptions"
          placeholder="Escolher"
          label-text="Cobertura básica"
          required
          item-text="nome"
          item-value="id"
          :return-object="true"
          @change="validateCoverage"
          :rules="[requiredInput]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <v-col cols="auto" class="colPos">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon
                color="secondary"
                size="12"
                v-on="on"
                class="iconTooltipLmi"
              >
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Limite Máximo Indenizável
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
          <BaseMoney
            id-element="insuredValueQuotation"
            placeholder="0,00"
            label-text="Valor Cobertura básica"
            v-model="valorCoverageSelected"
            required
            :rules="[requiredInput, aboveZero]"
            :readonly="readonly"
          />
        </v-col>
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="insuredValueQuotation"
          placeholder="0,00"
          label-text="Perda Produção Futura"
          v-model="editForm.perda_producao_futura"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="insuredValueQuotation"
          placeholder="0,00"
          label-text="Tratamento Fitossanitário"
          v-model="editForm.tratamento_fitossanitario"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pr-0 pr-sm-2">
        <v-col cols="auto" class="colPos">
          <v-tooltip bottom content-class="tooltip-label-form">
            <template v-slot:activator="{ on }">
              <v-icon
                color="secondary"
                size="12"
                v-on="on"
                class="iconTooltipPos"
              >
                fa-info-circle
              </v-icon>
            </template>
            <v-row>
              <v-col cols="12" class="px-4 py-3">
                <p class="white--text tooltip-label-text mb-0">
                  Participação Obrigatória do Segurado, valor ou percentual de
                  responsabilidade do segurado nos prejuízos indenizáveis
                  decorrentes de sinistros cobertos.
                </p>
              </v-col>
            </v-row>
          </v-tooltip>
          <BaseFormSelect
            id-element="paymentFormQuotation"
            placeholder="Escolher"
            label-text="POS"
            v-model="editForm.tipo_pos"
            :items="paymentConditions"
            item-text="nome"
            item-value="id"
            required
            :rules="[requiredInput]"
            :return-object="true"
            :readonly="readonly"
          />
        </v-col>
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="totalQuotation"
          placeholder="0,00"
          label-text="Prêmio Total"
          v-model="editForm.premio_total"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="federalSubventionQuotation"
          placeholder="0,00"
          label-text="Subvenção Federal"
          v-model="editForm.subvencao_federal"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row class="mb-8">
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="stateSubventionQuotation"
          placeholder="0,00"
          label-text="Subvenção Estadual"
          v-model="editForm.subvencao_estadual"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="totalQuotation"
          placeholder="0,00"
          label-text="Prêmio do Segurado"
          v-model="editForm.premio_segurado"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="totalQuotation"
          placeholder="0,00"
          label-text="Investimento R$/ha"
          v-model="editForm.investimento"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { requiredInput, aboveZero } from "@/utils/rules.js";
import BaseMoney from "../../../components/base/BaseMoney.vue";
import DocumentsMixin from "@/mixins/DocumentsMixin";

const TIPO_POS = [
  {
    id: "normal",
    nome: "Normal"
  },
  {
    id: "reduzida",
    nome: "Reduzida"
  }
];

const TIPO_COBERTURA = [
  {
    id: "granizo",
    nome: "Granizo"
  },
  {
    id: "granizo_geada",
    nome: "Granizo e Geada"
  }
];

const typeDecimal = {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  precision: 2,
  masked: false
};

export default {
  name: "QuotationProposalCafezal",
  mixins: [DocumentsMixin],
  components: { BaseMoney },
  data() {
    return {
      paymentConditions: TIPO_POS,
      typeDecimal,
      aboveZero,
      requiredInput,
      coverageOptions: TIPO_COBERTURA,
      selectedCoverage: null,
      valorCoverageSelected: 0
    };
  },
  created() {
    this.loadOptions();

    if (this.editForm.granizo > 0) {
      this.selectedCoverage = "granizo";
      this.valorCoverageSelected = this.editForm.granizo;
    } else if (this.editForm.granizo_geada > 0) {
      this.selectedCoverage = "granizo_geada";
      this.valorCoverageSelected = this.editForm.granizo_geada;
    }
  },
  computed: {
    ...mapState("quotation", ["insuranceCompanyOptions"]),
    getInsured() {
      return this.editForm.seguradora;
    }
  },
  methods: {
    ...mapActions("quotation", ["fetchInsuranceCompany"]),
    loadOptions() {
      if (
        this.insuranceCompanyOptions == null ||
        this.insuranceCompanyOptions.length == 0
      ) {
        let payload = {
          somenteAtivos: true,
          modalidade: "cafezal"
        };
        this.withLoading(this.fetchInsuranceCompany(payload));
      }
    },
    validateCoverage() {
      if (this.selectedCoverage.id == null) {
        this.$refs.coverageInput.validate();
      }
    },
    selectedCoverageValor() {
      let comboCoverageValue = this.selectedCoverage.id ?? this.selectedCoverage;
      if (comboCoverageValue == "granizo") {
        this.editForm.granizo_geada = 0;
        this.editForm.granizo = this.valorCoverageSelected;
      } else if (comboCoverageValue == "granizo_geada") {
        this.editForm.granizo = 0;
        this.editForm.granizo_geada = this.valorCoverageSelected;
      }
    }
  },
  watch: {
    valorCoverageSelected(newVal, oldVal) {
      if (oldVal != 0 || newVal != oldVal) {
        this.selectedCoverageValor();
      }
    },
    "selectedCoverage.id": {
      handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.valorCoverageSelected = 0;
          this.selectedCoverageValor();
        }
      },
      deep: true // Isso permite assistir profundamente propriedades aninhadas
    }
  },
  props: {
    editForm: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.iconTooltipPos {
  margin-bottom: -41px;
  margin-left: 37px;
}
.iconTooltipLmi {
  margin-bottom: -41px;
  margin-left: 180px;
}
.colPos {
  margin-top: -21px;
}
</style>
